import React, { useContext } from 'react';
import Logo from 'src/components/Logo';
import { AppContext } from 'src/containers/Core/AppContext';
import { AppState } from 'src/containers/Core/AppReducer';

import './style.scss';

const UserCard = () => {
  const { store } = useContext(AppContext);
  const { user }: AppState = store;

  return (
    <div className="d-flex">
      <div className={`user-info-card rounded`}>
        <Logo
          imageSrc={user.profilePicture}
          text={user.name}
          className="w-100 h-100"
          variant="rounded"
          inverse={true}
        />
      </div>
      <div className="d-flex flex-column pl-2">
        <span>{user.name}</span>
        <small className="opacity-7">{user.email}</small>
      </div>
    </div>
  );
};

export default UserCard;
